<template>
  <div>
    <!--<div style=" width: 400px; padding: 15px; background-color: #20a0ff; display: flex; flex-direction: column; justify-content: center; align-items: center;" ref="imageDom" >-->
      <!--<div style="margin-top: 30px; margin-bottom: 30px;">名字</div>-->
      <!--<div id="qrcode" style="width: 300px; height: 300px;"></div>-->
    <!--</div>-->

    <!--<el-button @click="clickGeneratePicture">生成下载链接</el-button>-->
    <!--<el-button @click="download">下载</el-button>-->
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
export default {
  name: 'Erweima',
  data(){
    return {
      // link: 'https://baidu.com',
      // firstFlag: true,
      // imgUrl:"",
    }
  },
  methods: {
    //  生成二维码
    // qrcode () {
    //   let that = this;
    //   let qrcode = new QRCode('qrcode', {
    //     width: 300,
    //     height: 300,        // 高度
    //     text:  this.link,   // 二维码内容
    //     // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    //     // background: '#f0f',   // 背景色
    //     // foreground: '#ff0'    // 前景色
    //   })
    // },
    // /**
    //  * 将页面指定节点内容转为图片
    //  * 1.拿到想要转换为图片的内容节点DOM；
    //  * 2.转换，拿到转换后的canvas
    //  * 3.转换为图片
    //  */
    // clickGeneratePicture() {
    //   html2canvas(this.$refs.imageDom).then(canvas => {
    //     // 转成图片，生成图片地址
    //     this.imgUrl = canvas.toDataURL("image/png");
    //     console.log(this.imgUrl);
    //     this.download();
    //   });
    // },
    // //下载图片
    // download() {
    //   this.downloadFile('测试.png', this.imgUrl);
    // },
    // //下载
    // downloadFile(fileName, content) {
    //   let aLink = document.createElement('a');
    //   let blob = this.base64ToBlob(content); //new Blob([content]);
    //
    //   let evt = document.createEvent("HTMLEvents");
    //   evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    //   aLink.download = fileName;
    //   aLink.href = URL.createObjectURL(blob);
    //
    //   // aLink.dispatchEvent(evt);
    //   //aLink.click()
    //   aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    // },
    // //base64转blob
    // base64ToBlob(code) {
    //   let parts = code.split(';base64,');
    //   let contentType = parts[0].split(':')[1];
    //   let raw = window.atob(parts[1]);
    //   let rawLength = raw.length;
    //
    //   let uInt8Array = new Uint8Array(rawLength);
    //
    //   for (let i = 0; i < rawLength; ++i) {
    //     uInt8Array[i] = raw.charCodeAt(i);
    //   }
    //   return new Blob([uInt8Array], {type: contentType});
    // },

  },

  // components: { QRCode },
  mounted(){
    // const that = this
    // this.$nextTick (function () {
    //   this.qrcode();
    // })
  }
}
</script>

<style scoped>

</style>
